var exports = {
  "W": "xf0b3b88a--9d5518--land-area",
};

module.exports = exports;
